/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { combineEpics } from 'redux-observable';
import { feeAdjustmentEpic } from './epics/pendingReservation';
import { submitOrderDetailsEpic } from './epics/submitOrderDetails';
import { filterAvailabilityBySearchEpic } from '../shared/epics/availability/filterAvailabilityBySearch';
import { sortAvailabilityEpic } from '../shared/epics/availability/sortAvailability';
import { filterAvailabilityByInputEpic } from '../shared/epics/availability/filterAvailabilityByInput';
import { compileDisplayableAvailabilitiesEpic } from '../shared/epics/availability/compileDisplayableAvailabilities';
import { processAvailabilityEpic } from '../shared/epics/availability/processAvailability';
import { updateEstimatePriceEpic } from '../shared/epics/availability/updateEstimatePrice';
import { updateAvailabilityEpic } from '../shared/epics/availability/updateAvailability';
import { fetchMonthlyAvailabilityEpic } from '../shared/epics/availability/fetchMonthlyAvailability';
import { fetchMonthlyAvailabilitySuccessEpic } from '../shared/epics/availability/fetchMonthlyAvailabilitySuccess';
import { modifyReservationEpic } from '../shared/epics/availability/modifyReservation';

export const rootEpic = combineEpics(
    feeAdjustmentEpic,
    submitOrderDetailsEpic,
    filterAvailabilityBySearchEpic,
    filterAvailabilityByInputEpic,
    sortAvailabilityEpic,
    compileDisplayableAvailabilitiesEpic,
    processAvailabilityEpic,
    updateAvailabilityEpic,
    updateEstimatePriceEpic,
    fetchMonthlyAvailabilityEpic,
    fetchMonthlyAvailabilitySuccessEpic,
    modifyReservationEpic
);
